import React from 'react'
import { Alert, Button, Space } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { EProductType } from 'models/product'

interface IProductInfoBannerProps {
  productType: EProductType
  onGoToParent?: () => void
  onDetachProduct?: () => void
  isDetaching?: boolean
}

export const ProductInfoBanner: React.FC<IProductInfoBannerProps> = ({
  productType,
  onGoToParent,
  onDetachProduct,
  isDetaching = false
}) => {
  if (productType === EProductType.PRODUCT) {
    return (
      <Alert
        message='Данный товар является основным'
        type='info'
        showIcon
        icon={<InfoCircleOutlined />}
        style={{ marginBottom: 24 }}
      />
    )
  }

  return (
    <Alert
      message={
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}>
          <span style={{ flex: 1, marginRight: 10 }} >
            Данный товар является вариацией,
            для редактирования характеристик перейдите к основному товару
          </span>
          <Space>
            <Button type='primary' onClick={onGoToParent}>
              Перейти к товару
            </Button>
            <Button
              danger
              onClick={onDetachProduct}
              loading={isDetaching}
            >
              Отсоединить товар
            </Button>
          </Space>
        </div>
      }
      type='info'
      showIcon
      style={{ marginBottom: 24 }}
    />
  )
}